<template>
  <!-- exhibition-business .eb -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">首页</BreadcrumbItem>
          <BreadcrumbItem>活动反馈</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
        <p class="header-tool-text">收集用户对活动的看法与意见</p>
      </div>
      <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="exportInfo('exhibitionActivityList')">
          <span>
            <i class="icon iconfont icon-shangchuan"></i>
          </span>
          <span>导出名单</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="活动名单" name="1">
          <exhibitionActivityList
            ref="exhibitionActivityList"
            v-if="String(showTabs) === '1'"
            @showNum="setNume"
          />
        </TabPane>
        <TabPane label="活动留言" name="2">
          <exhibitionActivityMsg
            ref="exhibitionActivityMsg"
            v-if="String(showTabs) === '2'"
            @showNum="setNume"
          />
        </TabPane>
      </Tabs>
    </div>
    <Contact />
  </div>
</template>

<script>
import exhibitionActivityList from "./subpages/exhibition-activity-list/exhibition-activity-list.vue";
import exhibitionActivityMsg from "./subpages/exhibition-activity-msg/exhibition-activity-msg.vue";
import Contact from "@components/Contact/Contact";
import { mapGetters } from "vuex";

export default {
  name: "exhibition-business",
  data() {
    return {
      flag: true,
      addBrandflag: false,
      addCaseflag: false,
      showTabs: "1",
      num: 0
    };
  },
  components: {
    exhibitionActivityList,
    exhibitionActivityMsg,

    Contact
  },
  created() {
    this.changeTab();
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  methods: {
    changeTab() {
      if (this.query && this.query.type && this.query.type === "match") {
        this.showTabs = "2";
        this.flag = false;
      }
      if (this.query && this.query.type && this.query.type === "expand") {
        this.showTabs = "3";
        this.flag = false;
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=my`);
        this.flag = true;
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=match`);
        this.flag = false;
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=expand`);
        this.flag = false;
      }
    },
    add(name) {
      this.$refs[name].showAdd();
    },
    addBrand() {
      this.addBrandflag = true;
    },
    addCase() {
      this.addCaseflag = true;
    },
    exportInfo(name) {
      // 导出数据
      this.$refs[name].exportInfo();
    },
    setNume(num) {
      this.num = num;
    }
  }
};
</script>

<style scoped lang="scss">
</style>
